<script setup>
import HomeWeb from '@/components/2026/topicRecruit/pageWeb/index.vue'
import HomeMobile from '@/components/2026/topicRecruit/pageMobile/index.vue'

const IS_Mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|HarmonyOS|OpenHarmony/i.test(navigator.userAgent);
const IS_H5 = IS_Mobile || window.innerWidth <= 768;

</script>

<template>
  <!-- /* 判读是从哪个入口进入 */ -->
  <HomeMobile v-if="IS_H5" />
  <HomeWeb v-else />
</template>

<style scoped>
@font-face {
  font-family: 'TypeRegular';
  src: url('@/fontFamily/360shouhuType-Regular.otf');
}
</style>
